import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useUserActionSendMessage } from '../../chatbot/hooks/userActions';
import { chatActions } from '../../common/reducers/chat';
import { selectConversationId } from '../../common/selectors/chat';
import { renderModel } from '../../util/renderModel';

const readQueryFromUrl = (): string | null => new URLSearchParams(window.location.search).get('query');

const readReferralFromUrl = (): string =>
  new URLSearchParams(window.location.search).get('referral') || 'Contact';

const removeQueryFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete('query');
  const newSearch = searchParams.toString();
  const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
  window.history.replaceState(null, '', newUrl);
};

export const useInitialQueryFromUrl = () => {
  const dispatch = useDispatch();
  const sendMessage = useUserActionSendMessage();
  const conversationId = useSelector(selectConversationId);
  const [query] = useState(readQueryFromUrl);
  const hasSent = useRef(false);

  useEffect(() => {
    if (query) {
      removeQueryFromUrl();
      dispatch(
        chatActions.setStartChatParameters({
          shouldStartNewChat: 'true',
          referral: readReferralFromUrl(),
        }),
      );
    }
  }, [dispatch, query]);

  useEffect(() => {
    if (!query || !conversationId || hasSent.current || !renderModel.getUserId()) {
      return;
    }
    hasSent.current = true;
    dispatch(chatActions.setStartChatParameters(undefined));
    dispatch(chatActions.setReloadStartChat(false));
    sendMessage({
      value: query,
      action_type: 'enter',
      attachments: [],
      isLiveChat: false,
    });
  }, [query, conversationId, sendMessage, dispatch]);
};
